import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#0a0a0a]" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-surface border border-emerald/30 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-197">
          {/* Subtle background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-emerald/5 rounded-full blur-3xl pointer-events-none" data-id="element-198" />

          <div className="relative z-10 flex flex-col items-center" data-id="element-199">
            <div className="w-20 h-20 bg-emerald/10 rounded-full flex items-center justify-center mb-8" data-id="element-200">
              <ShieldCheckIcon className="w-10 h-10 text-emerald" data-id="element-201" />
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold leading-tight max-w-2xl" data-id="element-202">
              Si en 30 días tu agenda no tiene más citas confirmadas, no nos
              pagas.
            </h2>
          </div>
        </motion.div>
      </div>
    </section>;
}